import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: "/atlas", // https://router.vuejs.org/api/#base
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return new Promise((resolve) => {
				// truputį palaukiam, kol DOM pasikeis
				setTimeout(() => {
					const el = document.querySelector(to.hash)
					if (el) {
						el.scrollIntoView({ behavior: 'smooth' })
					}
					resolve({ selector: to.hash })
				}, 300) // 300ms delay, gali reguliuoti pagal turinio įkėlimo greitį
			})
		}

		if (savedPosition) {
			return savedPosition
		}

		return { x: 0, y: 0 }
	},
});
export default router;

// BIG FIXME! Man nepatinka, kad base'as dubliuojasi čia ir vue.config.js faile! To neturi būti...